import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { SHOP_CATEGORIES } from '../../../constants/define/translation';

export const ShopCategoriesPageHeader = () => {
  const { t } = useTranslation(SHOP_CATEGORIES);

  const extra: ExtraHeaderPage[] = [];

  return <ContentPageHeader title={t('header.title')} extra={extra} sortingEnabled />;
};
